/* eslint-disable */

import moment from "moment";
import store from "../../../store";
import Flowit from "../../../services/flowit";
import { state } from "./mutations";
import * as types from "./types";

export const loadingData = ({ commit }, param) => {
  commit(types.LOADING_DATA, param);
};

export const load = ({ commit, state }, params) => {
  commit(types.LOADING_DATA, true);
  commit(types.RESOURCES, []);
  
  // Use passed params or fallback to state.filterParams
  const requestParams = params || state.filterParams;
  
  Flowit.deposits
  .list(requestParams)
  .then(response => {
    commit(types.RESOURCES, response.data.deposits);
    commit(types.SUBTOTAL, response.data.subtotal);
    commit(types.LIMIT, response.data.limit);
    commit(types.CURRENT_PAGE, response.data.page);
    commit(types.TOTAL_RESOURCES, response.data.resources);
    commit(types.SET_TOTAL_RESOURCES, response.data.resources);
    commit(types.LOADING_DATA, false);
  })
  .catch(error => {
    commit(types.ERRORS, error);
    commit(types.SHOW_ERROR, true);
    commit(types.LOADING_DATA, false);
  });
};

export const exportDeposits = ({ commit }, params) => {
  commit(types.LOADING_DATA, true);
  Flowit.deposits.exportDeposits(params).then(() => {});
  commit(types.LOADING_DATA, false);
};

export const downloadExport = ({ commit }, params) => {
  return Flowit.deposits.downloadExport(params).then(response => {
    if (response.data.download_url) {
      // Create a temporary link and click it to download
      const link = document.createElement('a');
      link.href = response.data.download_url;
      link.download = params.file_name || 'deposits_export.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    return response;
  });
};

export const checkExportStatus = ({ commit }) => {
  return Flowit.deposits.checkExportStatus();
};

export const showFilters = ({ commit }, param) => {
  commit(types.SHOW_FILTERS, param);
};
export const setPartner = ({ commit }, model) => {
  commit(types.SET_FILTER_PARTNER, model.business);
};

export const hideFilters = ({ commit }) => {
  commit(types.FILTER_VISIBLE, false);
};

export const resetFilters = ({ commit }) => {
  commit(
    types.SET_FILTER_INITIAL_DATE,
    moment()
      .startOf("month")
      .format("YYYY-MM-DD")
  );
  commit(
    types.SET_FILTER_FINAL_DATE,
    moment()
      .endOf("month")
      .format("YYYY-MM-DD")
  );
  commit(
    types.SET_FILTER_DEPOSIT_INITIAL_DATE,
    moment()
      .startOf("year")
      .format("YYYY-MM-DD")
  );
  commit(
    types.SET_FILTER_DEPOSIT_FINAL_DATE,
    moment()
      .endOf("year")
      .format("YYYY-MM-DD")
  );
  commit(types.SET_FILTER_CARD_BRAND, "");
  commit(types.SET_FILTER_STATUS, "");
  commit(types.SET_FILTER_OPERATION, "");
  commit(types.SET_FILTER_ORDINATION, "");
  commit(types.ORDINATION, null);
  commit(types.FILTER_STATUS, null);
  commit(
    types.FILTER_INITIAL_DATE,
    moment()
      .startOf("month")
      .format("YYYY-MM-DD")
  );
  commit(
    types.FILTER_FINAL_DATE,
    moment()
      .endOf("month")
      .format("YYYY-MM-DD")
  );
};

// eslint-disable-next-line no-unused-vars
export const get = ({ commit, rootState, dispatch }) => {
  const depositId = rootState.route.params.id;

  Flowit.deposits.get(depositId).then(response => {
    commit(types.SET_DEPOSIT_DATA, response.data);
  });
};

export const updateInitialDate = ({ commit }, newDate) => {
  commit(types.FILTER_INITIAL_DATE, newDate);
};

export const updateFinalDate = ({ commit }, newDate) => {
  commit(types.FILTER_FINAL_DATE, newDate);
};

export const updateStatus = ({ commit }, newStatus) => {
  commit(types.FILTER_STATUS, newStatus);
};

export const loadFilters = ({ commit }) => {
  commit(
    types.SET_FILTER_INITIAL_DATE,
    moment()
      .startOf("year")
      .format("YYYY-MM-DD")
  );
  commit(
    types.SET_FILTER_FINAL_DATE,
    moment()
      .endOf("year")
      .format("YYYY-MM-DD")
  );
  commit(types.SET_FILTER_DEPOSIT_INITIAL_DATE, null);
  commit(types.SET_FILTER_DEPOSIT_FINAL_DATE, null);
  commit(types.LIMIT, 10);
};

// eslint-disable-next-line no-unused-vars
export const setInitialDate = ({ commit }, date) => {
  commit(types.SET_FILTER_INITIAL_DATE, date);
};
// eslint-disable-next-line no-unused-vars
export const setFinalDate = ({ commit }, date) => {
  commit(types.SET_FILTER_FINAL_DATE, date);
};

// eslint-disable-next-line no-unused-vars
export const setDepositInitialDate = ({ commit }, date) => {
  commit(types.SET_FILTER_DEPOSIT_INITIAL_DATE, date);
};
// eslint-disable-next-line no-unused-vars
export const setDepositFinalDate = ({ commit }, date) => {
  commit(types.SET_FILTER_DEPOSIT_FINAL_DATE, date);
};

export const updateLimit = ({ commit }, param) => {
  commit(types.LIMIT, param);
  state.filterParams.limit = param;
};

export const updateCurrentPage = ({ commit }, param) => {
  commit(types.CURRENT_PAGE, param);
  state.filterParams.page = param;
};

export const setTotalResources = ({ commit }, param) => {
  commit(types.TOTAL_RESOURCES, param);
};

export const totalResources = ({ commit }, param) => {
  commit(types.TOTAL_RESOURCES, param);
};

export const updateOrdination = ({ commit }, newOrdination) => {
  commit(types.ORDINATION, newOrdination);
};
export const setStartAt = ({ commit }, param) => {
  store.state.deposits.filterParams.filterrific.with_created_at_between.start_at = param;
};
export const setStatus = ({ commit }, model) => {
  commit(types.SET_FILTER_STATUS, model.business);
};
export const setCardBrand = ({ commit }, cardBrand) => {
  commit(types.SET_FILTER_CARD_BRAND, cardBrand);
};
export const setOrdination = ({ commit }, ordination) => {
  commit(types.SET_FILTER_ORDINATION, ordination.business);
};
